import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import { isInstagram } from '../../../constants';
import { getInvertedColor } from '../../helpers';
import { useSettingsFromFacebook } from '../utils';
import { Avatar } from './Avatar';

export const Header = () => {
  const {
    headerBackgroundColor,
    nameCaptionType,
    nameCaptionCustom,
    nameCaptionReplyTime,
    name
  } = useSettings();

  const { name: pageName } = useSettingsFromFacebook();
  const actualName = pageName || name;

  const caption =
    {
      replyTime: nameCaptionReplyTime,
      custom: nameCaptionCustom,
      online: 'Online'
    }[nameCaptionType] ?? '';

  const textColor = getInvertedColor({ color: headerBackgroundColor });
  const borderColor = getInvertedColor({
    color: headerBackgroundColor,
    opacity: 0.1
  });

  return (
    <Component _background={headerBackgroundColor} _borderColor={borderColor}>
      <Avatar size={52} alt={actualName} showDot showBorder={isInstagram} />

      <Info>
        <Name _textColor={textColor}>{actualName}</Name>
        <AnswerTime _textColor={textColor}>
          <div
            dangerouslySetInnerHTML={{
              __html: caption
            }}
          />
        </AnswerTime>
      </Info>
    </Component>
  );
};

const Component = styled.div<{ _background?: string; _borderColor?: string }>`
  color: #111;
  display: flex;
  align-items: center;
  padding: 20px;

  background: ${({ _background }) => _background};
  border-bottom: ${({ _borderColor }) => `1px solid ${_borderColor};`};
`;

const Info = styled.div`
  margin-left: 16px;
  margin-right: 16px;
  width: 100%;
  overflow: hidden;
`;

const Name = styled.div<{ _textColor?: string }>`
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  max-height: 60px;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;

  color: ${({ _textColor }) => _textColor};
`;

const AnswerTime = styled.div<{ _textColor?: string }>`
  font-size: 13px;
  line-height: 18px;
  margin-top: 4px;

  color: ${({ _textColor }) => _textColor};

  p {
    margin: 0;
  }
`;
